import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import {
  nextStep as nextStepAction,
  updateAppointment as updateAppointmentAction,
} from 'actions';
import { getAppointment } from 'selectors/appointment';

import { SelectLocation as SelectLocationStep } from 'components/BookingSteps/SelectLocation/SelectLocation';

import AppointmentInfo from 'routes/book/AppointmentInfo';

import { TAppointmentHouseAddress } from 'types/appointment';

import { getClientFromCookie, setClientCookie } from 'utils/clientCookie';

type SelectLocationWrapperProps = {
  navigateToNextStep: ({ stepKey }: { stepKey: string }) => void;
};

const SelectLocation = ({ navigateToNextStep }: SelectLocationWrapperProps) => {
  const router = useRouter();
  const clientData = getClientFromCookie();

  const appointment = useSelector(getAppointment) || {};
  const appointmentHouseAddress: TAppointmentHouseAddress = {
    addressLine1: clientData.address?.addressLine1 ?? '',
    addressLine2: clientData.address?.addressLine2 ?? '',
    city: clientData.address?.city ?? '',
    zipCode: clientData.address?.zipCode ?? '',
    state: clientData.address?.state ?? '',
    inHouse: appointment.inHouse,
  };

  const dispatch = useDispatch();

  const updateAddress = (
    key: keyof TAppointmentHouseAddress,
    value: string | boolean,
  ) => dispatch(updateAppointmentAction(key, value));

  const goToNextStep = () => {
    // set next step only when we are in a booking process,
    // not in a waitlist
    if (router.pathname.includes('book')) {
      dispatch(nextStepAction());
    }

    navigateToNextStep({ stepKey: 'personal-info' });
  };

  const onSubmit = ({
    addressLine1,
    addressLine2,
    city,
    zipCode,
    state,
    inHouse,
  }: TAppointmentHouseAddress) => {
    if (inHouse) {
      updateAddress('addressLine1', addressLine1);
      updateAddress('addressLine2', addressLine2);
      updateAddress('city', city);
      updateAddress('zipCode', zipCode);
      updateAddress('state', state);

      clientData.address = {
        addressLine1,
        addressLine2,
        city,
        inHouse,
        zipCode,
        state,
      };

      setClientCookie(clientData);
    }

    updateAddress('inHouse', inHouse);

    goToNextStep();
  };

  return (
    <>
      <SelectLocationStep
        appointmentHouseAddress={appointmentHouseAddress}
        onSubmit={onSubmit}
      />
      <AppointmentInfo />
    </>
  );
};

export { SelectLocation };
